// Static stand-in for the markup `@payhook/unlock-button`'s UnlockButton.init
// renders into #payhook-button (payhook-js packages/unlock-button/index.js).
// Flows previews render this instead of constructing an UnlockButton, whose
// init() fires a `button_load` tracking event and whose click creates a real
// payment. Keep it byte-for-byte equivalent in structure so the page's CSS
// (which hides the widget's email field and styles `#payhook-button button`)
// applies identically.

// Same validation UnlockButton.init applies before showing an email
// (@payhook/core isValidEmail).
function isValidEmail (email) {
  return /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/.test(email || '')
}

function escapeAttribute (value) {
  return String(value).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]))
}

function renderUnlockCtaMarkup ({ email } = {}) {
  const known = isValidEmail(email) ? email : null
  return `
      <div>
        <div class="unlock-email-field">
          <input id="unlock-email" type="email" value="${known ? escapeAttribute(known) : ''}" placeholder="your@email.com" ${known ? 'readonly' : ''} />
          ${known ? '<button type="button" id="unlock-email-edit" class="unlock-email-edit">Edit</button>' : ''}
        </div>
        <button id="unlock">Unlock</button>
      </div>
    `
}

// Flows `?previewState=` values the unlock page honors.
const UNLOCK_PREVIEW_STATES = ['owned', 'buy']

module.exports = { isValidEmail, renderUnlockCtaMarkup, UNLOCK_PREVIEW_STATES }
